import { GetServerSideProps } from 'next'
import { MerchScreen } from 'app/features/merch/screen'
import { dehydrate, QueryClient } from 'react-query'
import { makeQuery as makeSingleQuery } from 'app/hooks/use-query'
import {
  createMerchPageQuery,
  mapToMerchPageContent,
} from 'app/queries/globals/merch'
import { listPrefetcher } from '../../lib/list-prefetcher'
import { collectiblesPrefetcher } from '../../lib/collectibles-prefetcher'
export default MerchScreen

export const getServerSideProps: GetServerSideProps = async (context) => {
  const queryClient = new QueryClient()
  const merchPageQuery = createMerchPageQuery()

  let data
  try {
    const res = await makeSingleQuery(merchPageQuery, {}, mapToMerchPageContent)
    data = await queryClient.fetchQuery(
      ['query', merchPageQuery, {}],
      async () => {
        return res
      }
    )
  } catch (e) {
    console.log(e)
    throw e
  }

  await Promise.all([
    listPrefetcher(queryClient, 'Collection', data?.merchCollection?.id, 12), // Merch items
    collectiblesPrefetcher(queryClient),
  ])

  const dehydratedState = dehydrate(queryClient)
  return {
    props: {
      dehydratedState,
    },
  }
}
